@if (item != null) {
	@if (isDate(item[type])) {
		{{ item[type] | date: 'MM/dd/yyyy' }}
	} @else if (isArray(item[type]) && item[type]?.length > 0) {
		@for (contact of item[type]; track contact) {
			<ng-container
				*ngTemplateOutlet="contactTemplate; context: { $implicit: contact }"
			/>
		}
	} @else if (isAddress(item[type])) {
		<ae-address-display [address]="item[type]" [includeAddressLink]="false" />
	} @else if (item['field'] === 'contacts.personal' && item[type]?.name) {
		<ng-container
			*ngTemplateOutlet="contactTemplate; context: { $implicit: item[type] }"
		/>
	} @else {
		{{ item[type]?.value ? item[type].value : (item[type] | ifEmpty) }}
		@if (item[type]?.notes) {
			<div class="text-muted">{{ item[type].notes }}</div>
		}
	}
}

<ng-template #contactTemplate let-item>
	<div>
		<!-- Name + Relationship -->
		<div>
			<span> {{ item.name }}{{ item.relationship ? ', ' : '' }} </span>
			@if (item.relationship) {
				<span>
					{{ item.relationship }}
				</span>
			}
		</div>
		<!-- Phones -->
		@if (item?.phones) {
			@for (phone of item.phones; track $index) {
				<div>
					<ng-container
						*ngTemplateOutlet="phoneTemplate; context: { $implicit: phone }"
					/>
				</div>
			}

			<!-- Emails -->
			@for (email of item.emails ?? []; track $index) {
				<div>
					{{ email }}
				</div>
			}

			<!-- Attributes -->
			@if (buildAttributeMessage(item.attributes); as attrMsg) {
				<span>{{ attrMsg }}</span>
			}
		} @else {
			<ng-container
				*ngTemplateOutlet="phoneTemplate; context: { $implicit: item }"
			/>
		}
	</div>
</ng-template>

<ng-template #phoneTemplate let-phone>
	<div>
		{{ phone.phone ?? phone.value | phone }}
		@if (phone.type) {
			@if (phone?.sms) {
				<i aria-hidden="true" class="far fa-comment-sms"></i>
			}
			<span>
				@switch (phone?.type) {
					@case ('cell') {
						<i aria-hidden="true" class="far fa-mobile"></i>
					}
					@case ('home') {
						<i aria-hidden="true" class="far fa-house"></i>
					}
					@case ('work') {
						<i aria-hidden="true" class="far fa-building"></i>
					}
				}
			</span>
		}
	</div>
</ng-template>
